import { render, staticRenderFns } from "./UsergroupPoDashboard.vue?vue&type=template&id=4cd48d84"
import script from "./UsergroupPoDashboard.vue?vue&type=script&lang=js"
export * from "./UsergroupPoDashboard.vue?vue&type=script&lang=js"
import style0 from "./UsergroupPoDashboard.vue?vue&type=style&index=0&id=4cd48d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports